<template>
  <div class="d-flex justify-content-center">
    <div class="mt-xl-8 mt-md-4 ipad-vertical">
      <div class="mt-sm-9 mt-md-6 mt-xl-0">
        <form role="form" @submit="validateForm">
          <div class="alert alert-primary" v-if="verify !== null">
            <i class="fa fa-thumbs-up"></i> Hesabınız başarıyla doğrulandı
          </div>
          <div class="alert alert-danger" v-if="result !== null">
            <i class="fa fa-exclamation"></i> {{ result }}
          </div>
          <base-input
            :disabled="loading"
            class="input-group-alternative mb-3"
            :placeholder="[[variables.get('email')]]"
            addon-left-icon="ni ni-email-83"
            type="email"
            v-model="model.email"
          >
          </base-input>
          <div
            class="alert alert-danger"
            v-for="(error, index) in validationErrors.email"
            :key="index + 1"
          >
            * {{ error }}
          </div>
          <password
            :disabled="loading"
            :placeholder="[[variables.get('password')]]"
            v-model="model.password"
            :show-password="false"
            :badge="false"
            :toggle="true"
            class="mb-3"
          />
          <div
            class="alert alert-danger"
            v-for="(error, index) in validationErrors.password"
            :key="index + 5"
          >
            * {{ error }}
          </div>
          <template>
            <vue-recaptcha
              ref="recaptcha"
              class="mb-3"
              @verify="markRecaptchaAsVerified"
              :sitekey="site_key"
            ></vue-recaptcha>
          </template>
          <div
            class="alert alert-danger"
            v-if="captchaCode.pleaseTickRecaptchaMessage"
          >
            {{ captchaCode.pleaseTickRecaptchaMessage }}
          </div>
          <div class="text-right">
            <base-button
              type="button"
              native-type="submit"
              class="btn bg-vg-green text-white w-100"
              :class="{ 'border-0': loading }"
              v-loading="loading"
              :disabled="loading"
            >
              <span>{{ variables.get("sign-in") }}</span>
            </base-button>
            <p class="text-center mb-0">
              <small class="text-grey font-montserrat"
                >Kayıtlı Değil Misiniz?</small
              >
              <router-link to="/register">
                <small class="text-vg-blue font-montserrat font-weight-bold">
                  {{ variables.get("register") }}
                </small>
              </router-link>
            </p>
            <p class="text-center">
              <small class="text-grey font-montserrat"
                >Şifrenizi mi Unuttunuz?</small
              >
              <router-link to="/reset-password">
                <small
                  class="pl-1 text-vg-blue font-montserrat font-weight-bold"
                  >{{ variables.get("forgot-password") }}</small
                >
              </router-link>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { variables } from "../langs/tr";
import Password from "vue-password-strength-meter";
import * as axios from "axios";
import LocalStorageService from "../services/local-storage-service";
import VueRecaptcha from "vue-recaptcha";
import { env } from "@/environments/env";

const localStorageService = LocalStorageService.getService();
export default {
  components: { Password, VueRecaptcha },
  name: "login",
  data() {
    return {
      captchaCode: {
        recaptchaVerified: false,
        pleaseTickRecaptchaMessage: "",
      },
      site_key: env.SITE_KEY,
      verify: null,
      loading: false,
      variables,
      result: null,
      validationErrors: {
        email: [],
        password: [],
      },
      model: {
        captcha_data: "",
        email: "",
        password: "",
      },
    };
  },
  created() {
    if (this.$route.query.verify) {
      this.verify = true;
    }
  },
  methods: {
    markRecaptchaAsVerified(response) {
      this.model.captcha_data = response;
      this.captchaCode.pleaseTickRecaptchaMessage = "";
      this.captchaCode.recaptchaVerified = true;
    },
    validateForm: function (e) {
      this.validationErrors = {
        email: [],
        password: [],
      };
      if (!this.captchaCode.recaptchaVerified) {
        this.captchaCode.pleaseTickRecaptchaMessage =
          "* Lütfen robot doğrulama işlemini yapınız.";
      }
      if (!this.model.email) {
        this.validationErrors.email.push("E-posta adresi gereklidir");
      }
      if (this.model.email && !this.validEmail(this.model.email)) {
        this.validationErrors.email.push("Hatalı e-posta adresi");
      }
      if (!this.model.password) {
        this.validationErrors.password.push("Şifre girilmesi zorunludur");
      }
      if (this.model.password && this.model.password.length < 6) {
        this.validationErrors.password.push("Şifreniz en az 6 karakter olmalı");
      }
      if (
        this.validationErrors.email.length === 0 &&
        this.validationErrors.password.length === 0 &&
        this.captchaCode.recaptchaVerified
      ) {
        this.login();
      }
      e.preventDefault();
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    login() {
      this.loading = true;
      axios
        .post("company/login", this.model)
        .then((response) => {
          if (response.status === 200) {
            let data = response.data;
            localStorageService.setAccessToken(data);
            this.$router.push("home");
          }
        })
        .catch((error) => {
          this.result = error.response.data.messages[0];
          this.loading = false;
          this.$refs.recaptcha.reset();
        });
    },
  },
};
</script>
<style>
.alert {
  padding: 0.5rem 1rem;
}
</style>
